import React from 'react';
import { navigate } from 'gatsby';
import * as Ink from '@carta/ink';
import { useAnalyticsV2 } from '@carta/fep-analytics';
import { getTopLevelNavItems, TopLevelNavItem } from './helpers/helpers';

export const MobileNavigation = () => {
  const topLevelItems = React.useMemo(() => getTopLevelNavItems(), []);
  const { trackAction } = useAnalyticsV2();

  const onNavClick = (item: TopLevelNavItem) => {
    trackAction({ elementId: `mobile-nav-${item.id}`, type: 'click' });

    if (item.isExternal) {
      window.open(item.route, '_blank');
    } else {
      navigate(item.route);
    }
  };

  return (
    <Ink.Dropdown
      align="left"
      trigger={props => (
        <Ink.Button {...props} type="transparent" aria-label="Navigation menu">
          <Ink.Icon type="hamburger" size="xxl" />
        </Ink.Button>
      )}
    >
      {topLevelItems.map(item => (
        <Ink.Dropdown.Item
          key={item.id}
          render={() => <Ink.Dropdown.Button onClick={() => onNavClick(item)}>{item.label}</Ink.Dropdown.Button>}
        />
      ))}
    </Ink.Dropdown>
  );
};
